export default "__VITE_ASSET__DDuxcqsA__"